import { render, staticRenderFns } from "./Webmaster.vue?vue&type=template&id=4a9ddb0a&scoped=true&"
import script from "./Webmaster.vue?vue&type=script&lang=js&"
export * from "./Webmaster.vue?vue&type=script&lang=js&"
import style0 from "./Webmaster.vue?vue&type=style&index=0&id=4a9ddb0a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9ddb0a",
  null
  
)

export default component.exports